<div class="admin-layout">
  <aside class="sidebar">
    <div class="sidebar-header">
      <h2 class="logo">LaBase Admin</h2>
    </div>

    @if (showMagasinSelector) {
      <div class="magasin-simulation-section">
        @if (magasinSimulation.isSimulating()) {
          <div class="simulation-banner">
            <div class="simulation-banner-content">
              <i class="pi pi-eye"></i>
              <span>Mode simulation: {{ magasinSimulation.simulatedMagasinNom() }}</span>
            </div>
            <button class="simulation-close-btn" (click)="clearSimulation()" title="Quitter le mode simulation">
              <i class="pi pi-times"></i>
            </button>
          </div>
        } @else {
          <div class="magasin-selector">
            <select
              class="magasin-select"
              [value]="selectedMagasinId != null ? '' + selectedMagasinId : ''"
              (change)="selectMagasin($event)"
            >
              <option value="">-- Simuler un magasin --</option>
              @for (magasin of magasins; track magasin.id) {
                <option [value]="'' + magasin.id">{{ magasin.nom }}</option>
              }
            </select>
          </div>
        }
      </div>
    }

    <nav class="sidebar-nav">
      @for (item of menuItems; track item.route) {
        <a
          [routerLink]="item.route"
          routerLinkActive="active"
          class="nav-item"
        >
          <i [class]="item.icon + ' nav-icon'"></i>
          <span class="nav-label">{{ item.label }}</span>
        </a>
      }

      <div class="nav-divider"></div>

      <button
        class="nav-item nav-item-button"
        (click)="openGuide()"
        title="Ouvrir le guide d'utilisation"
      >
        <i class="pi pi-book nav-icon"></i>
        <span class="nav-label">Guide d'utilisation</span>
      </button>
    </nav>

    <div class="sidebar-footer">
      @if (authService.currentUser(); as user) {
        <div class="user-info">
          <div class="user-avatar">
            {{ (user.prenom || '')[0] || '' }}{{ (user.nom || '')[0] || '' }}
          </div>
          <div class="user-details">
            <div class="user-name">{{ user.prenom }} {{ user.nom }}</div>
            <div class="user-role">{{ getProfilsLabel() }}</div>
          </div>
        </div>
      }
      <button class="btn-logout" (click)="logout()">
        <i class="pi pi-sign-out"></i>
        Déconnexion
      </button>
    </div>
  </aside>

  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
</div>
